export const i18n: any = {
  pt: {
    headerStep: "Confirmar pagamento",
    headerInfo: "R$ [AMOUNT]",
    terms: "Termos de uso",
    thanks: "Obrigado!",
    thanksSub: "Seu pagamento foi concluído.",
    thanksWaiting: "Aguardando o site",
    continue: "Continuar",
    configuredAccounts:
      "Você só pode depositar com uma conta bancária registrada no seu perfil. Acesse as configurações da conta para registrá-la antes de depositar.",
    disclaimer: [
      "Ao continuar, confirmo que concordo com os ",
      "Termos e Condições",
      "e li a",
      "Política de Privacidade",
    ],
    error: {
      back: "Voltar",
      tryAgain: "Tente novamente",
    },
    cpf: {
      error: "O formato deve ser 000.000.000-00",
    },
    feedback: {
      cancelAsk: "Tem certeza que quer sair?",
      cancelConfirm: "Sim, cancelar pagamento",
      cancelInfo: "Seu pagamento será cancelado e talvez precise começar de novo.",
      resume: "Não, continuar",
      title: "Pagamento Cancelado",
      header: "Poderia nos contar por que está indo embora? Sua resposta é anônima.",
      problemPix: "Tive um problema com o PIX",
      problemQR: "Tive um problema com o QR Code",
      problemTrust: "Não acho o serviço confiável",
      changeOfMind: "Eu mudei de ideia",
      other: "Outros",
      placeholder: "Você poderia elaborar? (Opcional)",
      submitAndClose: "Enviar feedback e fechar",
      return: "Fechar sem deixar feedback",
      feedbackThanks: "Agradecemos sua contribuição. Obrigado!",
    },
  },
  en: {
    headerStep: "Confirm payment",
    headerInfo: "R$ [AMOUNT]",
    terms: "Terms of use",
    thanks: "Thank you!",
    thanksSub: "Your payment is complete.",
    thanksWaiting: "Waiting for the site...",
    continue: "Continue",
    configuredAccounts:
      "You can only deposit from a bank account registered in your profile. Go to your account settings to register it before depositing.",
    disclaimer: [
      "By proceeding, I confirm that I agree to the ",
      "Terms and Conditions",
      "and have read the",
      "Privacy Policy",
    ],
    error: {
      back: "Go back",
      tryAgain: "Try again",
    },
    feedback: {
      cancelAsk: "Are you sure you want to leave ?",
      cancelConfirm: "Yes, cancel payment",
      cancelInfo: "Your payment will be canceled, and you may need to start over.",
      resume: "No, continue",
      title: "Payment Canceled",
      header: "Could you tell us why you’re leaving? It’s anonymous",
      problemPix: "I had an issue with PIX",
      problemQR: "I had an issue with the QR Code",
      problemTrust: "I didn't find the service trustworthy",
      changeOfMind: "I changed my mind",
      other: "Other",
      placeholder: "Could you elaborate? (Optional)",
      submitAndClose: "Send feedback and close",
      return: "Close without leaving feedback",
      feedbackThanks: "We appreciate your input. Thank you!",
    },
    cpf: {
      error: "Format should be 000.000.000-00",
    },
  },
};

const formatAmount = (input: string) => {
  if (!input) {
    return "0";
  }

  const cents = Number.parseInt(input, 10);

  const amountConvertedFromCents = cents / 100;

  const amount = amountConvertedFromCents.toFixed(2);

  return `${amount.replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
};

export const setupTexts = (locale: string, currency: string, cents: string) => {
  const t = i18n[locale];

  document.getElementById("t-h1")!.innerText = t["headerStep"];
  document.getElementById("t-h2")!.innerText = t["headerInfo"].replace("[AMOUNT]", formatAmount(cents));

  document.getElementById("t-f1")!.innerText = t["terms"];

  document.getElementById("t-t1")!.innerText = t["thanks"];
  document.getElementById("t-t2")!.innerText = t["thanksSub"];
  document.getElementById("t-t3")!.innerText = t["thanksWaiting"];

  document.getElementById("t-d1")!.innerText = t["disclaimer"][0];
  document.getElementById("t-d2")!.innerText = t["disclaimer"][1];
  document.getElementById("t-d3")!.innerText = t["disclaimer"][2];
  document.getElementById("t-d4")!.innerText = t["disclaimer"][3];

  document.getElementById("t-e-b1")!.innerText = t["error"]["back"];
  document.getElementById("t-e-b2")!.innerText = t["error"]["tryAgain"];
  document.getElementById("t-c-t")!.innerText = t["feedback"]["thanks"];

  document.getElementById("t-e-b1")!.innerText = t["error"]["back"];
  document.getElementById("t-e-b2")!.innerText = t["error"]["tryAgain"];

  document.getElementById("t-c-t")!.innerText = t["feedback"]["feedbackThanks"];
  document.getElementById("cpf-submit")!.innerText = t["continue"];
  document.getElementById("cpf-error-message")!.innerText = t["cpf"]["error"];
};
